import { render, staticRenderFns } from "./org_mng.vue?vue&type=template&id=5657cbf8&"
import script from "./org_mng.vue?vue&type=script&lang=js&"
export * from "./org_mng.vue?vue&type=script&lang=js&"
import style0 from "./org_mng.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports